// Peças da Conferência de Fatura reaproveitadas pelo MeuFrete (PO1-3160):
// o selo de situação e o alerta de vencimento. Extraídas do index.js sem
// mudança de comportamento; a conferência importa daqui.
import React from "react";
import moment from "moment";

import { dataPura } from "./formatters";
import "./styles.css";

// PO1-3191: Em Análise e Em Tratativa também são abertas e alertam vencimento.
export const SITUACOES_ALERTA_VENCIMENTO = ["EVA", "EAN", "ETR", "VAL", "BLO", "CON"];
export const DIAS_ALERTA_VENCIMENTO = 7;

export const STATUS_TONE = {
  AVA: "warning",
  EVA: "info",
  CAN: "danger",
  BLO: "danger",
  CON: "warning",
  VAL: "success",
  LIB: "info",
  PAG: "success",
  EAN: "warning",
  ETR: "info",
  PGO: "success",
};

export function StatusBadge({ codigo, tone, children }) {
  const cor = tone || STATUS_TONE[codigo] || "neutral";
  return (
    <span className={`conf-fatura-status conf-fatura-status--${cor}`}>
      {children || "-"}
    </span>
  );
}

// `situacoesAlerta` permite ao MeuFrete usar a regra dele (situações fora de
// CAN/LIB/PAG) sem mudar a da conferência.
export function getVencimentoAlert(f, situacoesAlerta = SITUACOES_ALERTA_VENCIMENTO) {
  if (
    !f ||
    !f.dataVencimentoExterna ||
    !situacoesAlerta.includes(f.situacaoCodigo)
  ) {
    return null;
  }

  const vencimento = dataPura(f.dataVencimentoExterna);
  if (!vencimento) return null;

  const diffDias = vencimento.diff(moment().startOf("day"), "days");
  if (diffDias < 0) {
    return {
      tone: "danger",
      label: `Fatura vencida há ${Math.abs(diffDias)} dia(s)`,
    };
  }
  if (diffDias === 0) {
    return { tone: "warning", label: "Fatura vence hoje" };
  }
  if (diffDias <= DIAS_ALERTA_VENCIMENTO) {
    return {
      tone: "warning",
      label: `Fatura vence em ${diffDias} dia(s)`,
    };
  }

  return null;
}
